module.exports = __webpack_public_path__ + "static/media/downloadsNew.ac8a9fc3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/SuperUser/components/img/downloadsNew.svg
// module id = 813
// module chunks = 0